module.exports = __webpack_public_path__ + "img/system-tools.ca483831.svg";